import React from "react";
import { HolidayKey } from "./types";
import { HOLIDAYS, Palette } from "./holidayConfig";
import { Glow, Rays, Vignette } from "./Atmosphere";
import EasterScene from "./scenes/EasterScene";
import MidsummerScene from "./scenes/MidsummerScene";
import HalloweenScene from "./scenes/HalloweenScene";
import ChristmasScene from "./scenes/ChristmasScene";
import LuciaScene from "./scenes/LuciaScene";

type SceneComponent = React.FC<{ p: Palette; dark: boolean }>;

const SCENES: Record<HolidayKey, SceneComponent> = {
  easter: EasterScene,
  midsummer: MidsummerScene,
  halloween: HalloweenScene,
  lucia: LuciaScene,
  christmas: ChristmasScene,
};

interface HolidayBackdropProps {
  holiday: HolidayKey;
  dark: boolean;
}

/**
 * Det dekorerade bakgrundslagret. Ligger fast bakom allt innehåll och
 * släpper igenom alla klick. Monteras om när tema byts så att partiklar och
 * animationer startar från början.
 */
const HolidayBackdrop: React.FC<HolidayBackdropProps> = ({ holiday, dark }) => {
  const Scene = SCENES[holiday];
  const p = HOLIDAYS[holiday].palette;
  return (
    <div
      key={`${holiday}-${dark ? "dark" : "light"}`}
      className={`holiday-backdrop holiday-backdrop-${holiday}`}
      aria-hidden="true"
    >
      {/* Midsommar har ingen egen himmel – där ligger ljuset bakom scenen */}
      {holiday === "midsummer" && (
        <>
          <Glow p={p} />
          <Rays right="-20vw" />
        </>
      )}
      <Scene p={p} dark={dark} />
      {holiday !== "easter" && <Vignette />}
    </div>
  );
};

export default HolidayBackdrop;
